import { useTranslation } from 'react-i18next';

import type { CategorySidebarListItem, ControlMessageCategory } from '@/types/category';

import { ADD, ALL, EDIT } from '@/constants';

export function useCategoryListItems(
  messages: ReadonlyArray<{ predefinedMessageCategoryId: number }>,
  categories: ControlMessageCategory[]
): CategorySidebarListItem[] {
  const { t } = useTranslation();

  return [
    {
      id: ALL,
      name: t('common:configuration.controlMessages.allItems'),
      editable: false,
      total: messages.length,
    },
    ...categories.map(({ id, name, editable, totalMessages }) => ({
      id,
      name,
      editable,
      total: totalMessages,
    })),
  ];
}

const EDIT_FORM_PREFIX = `${EDIT}-`;

export function parseEditingCategoryId(categoryForm: string): number | null {
  if (!categoryForm.startsWith(EDIT_FORM_PREFIX)) {
    return null;
  }

  const parsed = Number(categoryForm.replace(EDIT_FORM_PREFIX, ''));

  return Number.isFinite(parsed) ? parsed : null;
}

export function getCategoryFormConditionalProps(
  categoryForm: string,
  editingCategoryId: number | null,
  editingCategory: ControlMessageCategory | null
) {
  if (categoryForm === ADD) {
    return { mode: ADD, categoryFormInitialName: '' };
  }

  return {
    mode: EDIT,
    predefinedMessageCategoryId: editingCategoryId!,
    initialName: editingCategory?.name,
  };
}
